export function parseJson(value: string) {
  const trimmed = value.trim();
  return trimmed ? JSON.parse(trimmed) : {};
}

export function prettyJson(value: unknown) {
  return JSON.stringify(value || {}, null, 2);
}
